module.exports = __webpack_public_path__ + "static/media/fa-regular-400.bb370ac4.woff2";